import { RGBColor } from 'react-color';

export function hexToRgb(color: string): RGBColor {
  let r = 0;
  let g = 0;
  let b = 0;

  // 3 digits
  if (color.length === 4) {
    r = Number('0x' + color[1] + color[1]);
    g = Number('0x' + color[2] + color[2]);
    b = Number('0x' + color[3] + color[3]);

    // 6 digits
  } else if (color.length === 7) {
    r = Number('0x' + color[1] + color[2]);
    g = Number('0x' + color[3] + color[4]);
    b = Number('0x' + color[5] + color[6]);
  }

  return {
    r,
    g,
    b,
  };
}

const componentToHex = (c: number) => {
  const hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
};

export function rgbToHex(color: RGBColor): string {
  return '#' + componentToHex(color.r) + componentToHex(color.g) + componentToHex(color.b);
}

export const rgbArrayToHex = (color: number[]): string => {
  return rgbToHex({ r: color[0], g: color[1], b: color[2] });
};

export const rgbaObjectToCss = (color: RGBColor | undefined | null): string => {
  if (!color) {
    return 'rgba(0, 0, 0, 1)';
  }

  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a ?? 1})`;
};

// between 0 and 1
export const normalizeRgbColor = (color?: RGBColor): RGBColor | undefined => {
  return color
    ? {
        r: color.r / 255,
        g: color.g / 255,
        b: color.b / 255,
        a: color.a,
      }
    : undefined;
};

export const restoreRgbColor = (color?: RGBColor): RGBColor | undefined => {
  return color
    ? {
        r: Math.round(color.r * 255),
        g: Math.round(color.g * 255),
        b: Math.round(color.b * 255),
        a: color.a,
      }
    : undefined;
};
